import { Button, Flex, Modal, Text } from '@mantine/core';

export const CRITICAL_ISSUES_MESSAGE =
  'You have some critical issues. Please fix them before generating the report.';

export function CriticalIssuesModal({ opened, onClose }) {
  return (
    <Modal
      id="critical-issues-modal"
      opened={opened}
      onClose={onClose}
      centered
      radius="sm"
      size="sm"
      title="Critical issues found"
    >
      <Text id="critical-issues-modal-message" c="gray.7" fz="sm" mb="24">
        {CRITICAL_ISSUES_MESSAGE}
      </Text>
      <Flex justify="flex-end">
        <Button id="critical-issues-modal-close-btn" onClick={onClose}>
          Got it
        </Button>
      </Flex>
    </Modal>
  );
}
